import React, { useEffect, useRef } from 'react'

import styles from './Main.module.css'
import { useRouter } from 'next/router'

const Main = ({
	children,
	...props
}: React.DetailedHTMLProps<
	React.HTMLAttributes<HTMLDivElement>,
	HTMLDivElement
>): JSX.Element => {
	const { events } = useRouter()
	const mainRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (typeof document === 'undefined') return
		const mainElement = document.querySelector('main')

		if (!mainElement) return

		const handleRouteChange = (
			url: string,
			{ shallow }: { shallow: boolean }
		): void => {
			/**
			 * Don't scroll for query parameter changes (shallow routing)
			 */
			if (shallow) {
				return
			}

			/**
			 * Don't scroll if the route is a search keyword page (we hijack this elsewhere)
			 */
			if (url.startsWith('/track/searchkeyword')) {
				return
			}

			mainElement.scrollTo(0, 0)
		}

		events.on('routeChangeComplete', handleRouteChange)

		return () => {
			events.off('routeChangeComplete', handleRouteChange)
		}
	}, [events])

	return (
		<main className={styles.main} id="main-content" ref={mainRef} {...props}>
			{children}
		</main>
	)
}

export default Main
